import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { base64ToFile, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { MembersService } from '../members.service';

interface Data {
  id: number;
}

@Component({
  selector: 'app-members-file-send',
  templateUrl: './members-file-send.component.html',
  styleUrls: ['./members-file-send.component.css'],
})
export class MembersFileSendComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  uploadProgress: number;

  id: number;

  constructor(
    public dialog: MatDialogRef<MembersFileSendComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: Data,
    private memberService: MembersService,
    private toastrService: ToastrService
  ) {
    this.id = this.data?.id;
  }

  ngOnInit(): void {}

  sendFile() {
    const originalFile: File = this.imageChangedEvent.target.files[0];
    const uploadData = new FormData();
    const blob = base64ToFile(this.croppedImage);

    uploadData.append('avatar', blob, originalFile.name);
    uploadData.append('user_id', this.id.toString());

    this.memberService.changeAvatar(this.id, uploadData).subscribe((event) => {
      if (event.type == HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round((100 * event.loaded) / event.total);
      }
      if (event.type == HttpEventType.Sent) {
        //alert('enviado com sucesso!');
      }
      if (event.type == HttpEventType.Response) {
        this.toastrService.success(event.body['message']);
        if (event.status === 200) {
          this.dialog.close(true);
        }
      }
    });
  }

  // image cropper functions
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}
